module.exports = __webpack_public_path__ + "static/media/navReviewed.d3007bbb.svg";